import React, { useEffect, useState } from 'react'
import { ConversationContainer, useStateContext } from '@xkit-yx/im-kit-ui'
import SearchBar from './SearchBar'
import general, { redux } from '../../general'
import { SwipeAction } from 'antd-mobile'
import { NavLink } from '../../lib/Navigation'
import Session from './Session'
import { PubSub } from 'pubsub-js'
import { useLocalStorageState } from 'ahooks'
import Manager from '../components/Manager'

export default function Conversation() {

  const { store, nim } = useStateContext()
  const [item, setItem] = useState({})
  const [rightActions, setRightActions] = useState([])
  const [muteArray, setMuteArray] = useLocalStorageState(`chat-mute-list-${localStorage.getItem('yx_account')}`,[])

  useEffect(()=>{
    if (muteArray.length == 0){
      store.sessionStore.sessions.forEach(session => {
        getTeamMembers(session.to)
      })
    }
  },[])

  useEffect(() => {

    PubSub.subscribe('chat-mute-change', (name,teamId) => {
      getTeamMembers(teamId)
    })

    redux.subscribe(() => {
      let clearChatUnRead = redux.getState().clearChatUnRead;
      if (clearChatUnRead) {
        store.sessionStore.sessions.forEach((session, sessionId) => {
          clearUnread(sessionId)
        })
      }
    })
  }, [])

  const clearUnread = (sessionId) => {
    store.sessionStore.resetSession(sessionId).then(res => {

    })
  }

  function updateInfoInTeamDone(error, obj) {
    if (obj.muteNotiType == '0') {
      muteArray.splice(muteArray.indexOf(obj.teamId), 1);
      setMuteArray([...muteArray])
    } else {
      const id = obj.teamId
      if (muteArray.includes(id)) {
        return
      }
      let array = muteArray ? muteArray : [];
      if(!muteArray.includes(id)) {
        array.push(id);
        setMuteArray(array);
      }
    }
  }

  const getTeamMembers = (teamId) => {
    nim.getTeamMembers({
      teamId: teamId,
      accounts: [localStorage.getItem('yx_account')]
    }).then(members => {
      const member = members.filter(member => member.account == localStorage.getItem('yx_account'))
      
      if (member[0].muteNotiType == 1) {
        const id = member[0].teamId
        let array = muteArray ? muteArray : [];
        if(!muteArray.includes(id)) {
          array.push(id);
          setMuteArray(array);
        }
      } else {
        muteArray.splice(muteArray.indexOf(member[0].teamId), 1);
        setMuteArray([...muteArray])
      }
    })
  }

  useEffect(() => {

    setRightActions([
      {
        key: 'unsubscribe',
        text: muteArray.includes(item.teamId) ? '取消免打扰' : `免打扰`,
        color: '#CCCCCC',
        onClick: () => {
          if (!muteArray.includes(item.teamId)) {
            store.sessionStore.resetSession(item.id).then(() => {
              redux.dispatch({
                type: 'updateChatUnread',
                data: {
                  updateChatUnread: true
                }
              })
            })
            nim.nim.updateInfoInTeam({
              teamId: item.teamId,
              muteNotiType: '1',
              done: updateInfoInTeamDone
            })
          } else {
            setTimeout(() => {
              redux.dispatch({
                type: 'updateChatUnread',
                data: {
                  updateChatUnread: true
                }
              })
            }, 100);
            nim.nim.updateInfoInTeam({
              teamId: item.teamId,
              muteNotiType: '0',
              done: updateInfoInTeamDone
            })
          }
        }
      },
      {
        key: 'mute',
        text: item.stickTopInfo?.isStickOnTop === true ? '取消置顶' : '置顶',
        color: '#4E94FE',
        onClick: () => {
          if (item.stickTopInfo?.isStickOnTop == true) {
            store.sessionStore.deleteStickTopSessionActive(item.id)
          } else {
            store.sessionStore.addStickTopSessionActive(item.id)
          }
        }
      },
      {
        key: 'delete',
        text: '删除',
        color: '#FF596A',
        onClick: () => {
          store.sessionStore.resetSession(item.id).then(() => {
            redux.dispatch({
              type: 'updateChatUnread',
              data: {
                updateChatUnread: true
              }
            })
            store.sessionStore.deleteSessionActive(item.id).then(() => {
            
            })
          })
        }
      },
    ])
  }, [item,muteArray])

  return (
    <div>
      {store.uiStore?.sessions?.length == 0 ? <Session></Session> :
        <div className='conversation-index'>
          <SearchBar></SearchBar>
          <ConversationContainer
            prefix='game-box'
            renderSessionListEmpty={() => <div></div>}
            renderCustomTeamSession={option => {
              return (
                <SwipeAction key={option.session.teamId} onActionsReveal={() => {
                  setItem(option.session)
                }} rightActions={rightActions}>
                  <NavLink onClick={()=>{
                    setItem(option.session)
                    Manager.push({event_id:'A-5-11-4'})
                  }} to={"/chat?tid=" + option.session.teamId} className='game-box-item'>
                    {option.session.stickTopInfo?.isStickOnTop && <div className='game-box-item-content-stickTop'>
                      <img src="resources/250410/stickTop.png" alt="" />
                    </div>}
                    <div className='ant-badge'>
                      <img className='ant-avatar-image' src={option.session.avatar} alt="" />
                      <div className="ant-tip">
                        <img height={15} src="resources/250410/guan.png" alt="" />
                      </div>
                    </div>
                    <div className='game-box-item-content'>
                      <div className='game-box-item-content-name'>
                        <div className='game-box-item-content-tname'>{option.session.name}</div>
                      </div>
                      <div className='game-box-item-content-msg'>
                        <div className='game-box-item-content-msg-body'>{(() => {
                          let lastMsg = ''
                          if (option.session.lastMsg){
                            if (option.session.lastMsg.type == 'notification') {
                              lastMsg = '[通知消息]'
                            } else if (option.session.lastMsg.type == 'custom') {
                              if (option.session.lastMsg.subType == 1) {
                                lastMsg = '[活动消息]'
                              } else if (option.session.lastMsg.subType == 2) {
                                lastMsg = '[攻略消息]'
                              } else if (option.session.lastMsg.subType == 3) {
                                lastMsg = '[交易消息]'
                              } else if (option.session.lastMsg.subType == 4) {
                                lastMsg = '[攻略消息]'
                              } else if (option.session.lastMsg.subType == 5) {
                                lastMsg = '[活动消息]'
                              } else if (option.session.lastMsg.subType == 6) {
                                lastMsg = '[红包通知]'
                              } else if (option.session.lastMsg.subType == 7) {
                                lastMsg = '[红包消息]'
                              } else if (option.session.lastMsg.subType == 8) {
                                lastMsg = '[红包通知]'
                              } else if (option.session.lastMsg.subType == 9) {
                                lastMsg = '[公告消息]'
                              } else if (option.session.lastMsg.subType == 10 || option.session.lastMsg.subType == 11) {
                                lastMsg = '[活动消息]'
                              }
                            } else if (option.session.lastMsg.type == 'video') {
                              lastMsg = '[视频消息]'
                            } else if (option.session.lastMsg.type == 'image') {
                              lastMsg = '[图片消息]'
                            } else if (option.session.lastMsg.type == 'tip') {
                              lastMsg = '[通知消息]'
                            } else {
                              if (option.session.lastMsg.body) {
                                lastMsg = option.session.lastMsg.body
                              } 
                            }
                          }
                          return lastMsg
                        })()}</div>
                      </div>
                    </div>
                    <div className='game-box-item-noti'>
                      {muteArray.includes(option.session.teamId) ? <img className='muteNoti' src='resources/im/miandarao.png' alt='' /> :
                        <div className={'game-box-item-content-badge-count ' + (option.session.unread == 0 ? 'clear' : '')}>
                          {option.session.unread > 99 ? '99' : option.session.unread}
                        </div>
                      }
                    </div>
                  </NavLink>
                </SwipeAction>
              )
            }}
          ></ConversationContainer>
        </div>}
    </div>

  )
}
